exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".i0aojaPAz79sxNMwBbAZoA\\=\\={position:relative;width:calc(100% - 60px);height:100%}html[dir=ltr] .i0aojaPAz79sxNMwBbAZoA\\=\\={left:60px;right:0}html[dir=rtl] .i0aojaPAz79sxNMwBbAZoA\\=\\={right:60px;left:0}.rOQOiba3chtY-xVkmeIPYw\\=\\={position:absolute;width:100%}", ""]);
// Exports
exports.locals = {
	"stylistScreen": "i0aojaPAz79sxNMwBbAZoA==",
	"range": "rOQOiba3chtY-xVkmeIPYw=="
};